export { Notice } from './Notice';
export type { Props } from './Notice.types';
